<template>
    <Modal v-model="openForm" footer-hide fullscreen>
        <div id="tata">
            <div id="tatleft">
                <div v-if="true">
                    <ly-form-item label="选择车辆">
                        <select-car placement="left" :name="carNo" @update:name="carNo = $event" :deviceNo="deviceNo"
                            @update:deviceNo="deviceNo = $event" filterGroup="车辆"></select-car></ly-form-item>
                    <ly-form-item label="开始时间">
                        <DatePicker type="datetime" placement="bottom-end" placeholder="请输入时间信息" v-model="startTime"
                            style="width: 100%" :clearable="false"></DatePicker>
                    </ly-form-item>
                    <ly-form-item label="结束时间">
                        <DatePicker type="datetime" placement="bottom-end" placeholder="请输入时间信息" v-model="endTime"
                            style="width: 100%" :clearable="false"></DatePicker>
                    </ly-form-item>
                    <Button @click="getGuiji" long type="primary">查询轨迹</Button>
                </div>
                <p style="margin-top: 20px;margin-bottom: 10px;">规则列表</p>
                <ul id="tcgzlist">
                    <li :class="{ active: now == index }" v-for="(item, index) in items"
                        :key="index">
                       <p>{{ item.name }}</p> 
                       <p>
                        <a @click="clickItem(item, index,1)" size="small">正向</a>
                        <a @click="clickItem(item, index,2)" size="small">反向</a>
                    </p>
                    </li>
                </ul>
            </div>
            <div id="tatright">
                <div id="tatrightTop">
                    <my-map ref="gmap" @point="rePoint" :isNavg="true" type="car"></my-map>
                </div>
                <div id="tatrightBottom">
                    <tlist @row="reRow" :tableData="tableData">

                    </tlist>
                </div>
            </div>
        </div>
    </Modal>
</template>
<script>
import myMap from "../map/locusMap.vue";
import tlist from "./tlist.vue";
export default {
    components: { myMap, tlist },
    data() {
        return {
            openForm: false,
            deviceNo: '',
            carNo: '',
            startTime: new Date(Date.now() - 3600000 * 2),
            endTime: new Date(),
            items: [],
            now: -1,
            tableData:[]
        }
    },
    methods: {
        open() {
            this.openForm = true;
            this.getRuleList();
        },
        rePoint(v) {

        },
        getRuleList() {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.trp + "/timesRule/list",
                data: {},
            }).then((res) => {
                this.$Spin.hide(); //关闭加载

                var data = res.data.data.dataList;
                this.items = data;
                console.log(data);
            });
        },
        getGuiji() {
            var item = {
                deviceNo: this.deviceNo,
                startTime: this.startTime.getTime(),
                endTime: this.endTime.getTime(),
                returnCoord: 2
            }
            console.log(item);
            this.axios({
                method: "post",
                //url: this.axios.lbs + "/locus/getPlyLocus",
                url: this.axios.lbs + "/locus/getOrgLocus",
                data: item,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                var data = res.data.data.dataList;

                console.log(data);
                if (data.length >= 1) {
                    var lnglat = [];
                    for (let i = 0; i < data.length; i++) {
                        lnglat.push([data[i].returnX, data[i].returnY]);
                        data[i].tms = data[i].gpsTime / 1000;
                        data[i].locateLng = data[i].returnX;
                        data[i].locateLat = data[i].returnY;
                        data[i].gpsTime1 = this.utils.time(data[i].gpsTime);
                        data[i].recordTime1 = this.utils.time(data[i].recordTime);
                        data[i].startParkTime = this.utils.time(data[i].startParkTime);
                        data[i].endParkTime = this.utils.time(data[i].endParkTime);

                        data[i].parkDuration1 = this.utils.duration(data[i].parkDuration);

                        data[i].accStatus1 = this.$t("accStatus." + data[i].accStatus);
                        data[i].mileage1 = (data[i].mileage - data[0].mileage).toFixed(1);
                        data[i].flag1 = this.$t("flag." + data[i].flag);
                        //console.log(data[i].directionDegree,data[i].deviceStatus,data[i].mileage);
                    }

                    this.$refs.gmap.loadUi(lnglat, data); //渲染轨迹


                } else if (data.length == 0) {
                    this.$Message.error("暂无轨迹");
                    this.$refs.gmap.loadUi([], []); //清空轨迹
                    this.$refs.gmap.showpark([], 0); //清空停车点

                }
                this.tableData=data;
            });
        },
        clickItem(item, index,t) {
            this.now = index;
            console.log(item);//fwdMarkerList
            if (t===1) {
                this.$refs.gmap.showPoints(item.fwdMarkerList)
            } else {
                this.$refs.gmap.showPoints(item.bwdMarkerList)
            }
            
        },
        reRow(v) {
            this.$refs.gmap.drawPoint(v);
        }
    },
}
</script>
<style>
#tata {
    display: flex;
    height: 100%;
}

#tatleft {
    width: 240px;
    height: 100%;
    padding: 10px;
}
#tatleft ul {
    height: calc(100% - 200px);
    overflow: auto;
}
#tatleft ul li{
    display: flex;
}
#tatleft ul li p:first-child {
    width:calc(100% - 70px);
    height: 1.2em;
    overflow: hidden;
}
#tatleft ul li p:last-child {
    width:70px;
}
#tatright {
    width: calc(100% - 240px);
    height: 100%
    
}

#tatrightTop {
    height: calc(100% - 200px);
}

#tatrightBottom {
    height: 200px;
}

#tcgzlist li {
    padding: 4px;
    cursor: pointer;
}

#tcgzlist li.active {
    background: #dae6fb;
}
</style>


// WEBPACK FOOTER //
// src/components/tangci/tangcifenxi.vue